import { createBillsUrl } from "@components/bills/lib/billsUrl";
import { createInvoicesUrl } from "@components/invoices/lib/invoicesUrl";
import { createTransactionsUrl } from "@components/transactions/lib/transactionsUrl";
import { SCHEDULES_REVIEW_VIEW_ID } from "@components/transactions/views/SchedulesReviewView";
import { ApplySourceDestination } from "./ScheduleApplySourcePicker";

export function createScheduleApplyNavigateUrl(params: {
    destination: ApplySourceDestination;
    entityIds: number[];
    scheduleTemplateId: string;
}): string {
    if (params.destination === "transactions") {
        return createTransactionsUrl(
            { entityIds: params.entityIds },
            {
                view: SCHEDULES_REVIEW_VIEW_ID,
                scheduleTemplateId: params.scheduleTemplateId,
            },
        );
    }
    if (params.destination === "bills") {
        return createBillsUrl(
            { entityIds: params.entityIds },
            { scheduleTemplateId: params.scheduleTemplateId },
        );
    }
    return createInvoicesUrl(
        { entityIds: params.entityIds },
        { scheduleTemplateId: params.scheduleTemplateId },
    );
}
